<shopping-cart-button
        [product]="product"
        [clientType]="viewType"
        [data]="cartData"
        [xClient]="xClient">
</shopping-cart-button>
